import { Component, Inject, OnInit, Injectable, Injector, OnDestroy } from '@angular/core';
import {Router} from "@angular/router";
import { ENVIRONMENT, Navbar } from '@ot/shared/model';
import { NavbarFactoryService } from '@ot/shared/navbar';
import { LocationStrategy } from '@angular/common';
import {
  AuthService,
  Environment,
  EnvironmentConfigService,
  EsDomainCheckService,
  UIAppsBaseURLs,
  UtilsService
} from '@ot/shared/utils';


@Component({
  selector: 'ot-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  navbar: Navbar;
  applicationName: string;
  appId: string;

  // For local development usages.
  readonly IFTA_LOCAL_PORT = '4200';

  constructor(
    @Inject(ENVIRONMENT) private environment: Environment,
    private environmentConfigService: EnvironmentConfigService,
    private navbarFactory: NavbarFactoryService,
    private esDomainCheckService: EsDomainCheckService,
    public authService: AuthService,
    private injector: Injector,
    private locationStrategy: LocationStrategy
  ) {
    const uIAppsBaseURLs: UIAppsBaseURLs = UtilsService.buildUIAppsBaseUrls(
      this.environmentConfigService.getEnvironmentConfigs().clients,
      this.environment.appName
 
    );
    this.applicationName = this.environment.appName;
    this.setAccessToken();
    this.authService.prepareRedirectUrl(this.IFTA_LOCAL_PORT);
    this.navbar = this.navbarFactory.getNavbar(
 
      uIAppsBaseURLs,
      this.authService.hasAdministratorPrivileges()
    );
    this.redirectNavigation();
  }
 
  ngOnInit(): void {
    this.esDomainCheckService.notifyIfRedirected();
  }
 
  logOut(){
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = this.getLoginURL() + '/logout.jsp';
  }
  // To get the login url for rest api
  getLoginURL() {
    const hostArr = location.host.split('.');
    hostArr.shift();
    const DYNAMIC_ENV_DOMAIN = hostArr.join('.');
    return window.location.protocol + '//login.' + DYNAMIC_ENV_DOMAIN;
  }
  
  setAccessToken() {
    let accessToken = localStorage.getItem('access_token');
    if (!accessToken && location.hash.indexOf('access_token=') > -1) {
      accessToken = location.hash.split('&')[0].split('access_token')[1].split('=')[1];
      localStorage.setItem('access_token', accessToken);
      const currentUrl = this.locationStrategy.path().split('#')[0];
      history.replaceState({}, '', currentUrl);
    }
 
    if (accessToken) {
      const base64Url = accessToken.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      const token = window.atob(base64);
      localStorage.setItem('decoded_token', token);
    }
    return accessToken;
  }
 
  redirectNavigation() {
    const router = this.injector.get(Router);
    if (localStorage.getItem("iftaPath")) {
      router.navigateByUrl(localStorage.getItem("iftaPath"));
    } else {
      console.log("Invalid path");
    }
  }
}